export const getHeaderStepStatus = (stepIndex: number, currentStepIndex: number) => {
  if (stepIndex === currentStepIndex) {
    return "active";
  } else if (stepIndex < currentStepIndex) {
    return "complete";
  }
  return "inactive";
};
